// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2htP1","fileBtn":"File_fileBtn__27w6H","closeBtn":"File_closeBtn__DBAoz","fileSelected":"File_fileSelected__2G9OE","disabled":"File_disabled__22Lre"};